@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(-126_289_806)
internal val Res.plurals.activity__list_items_added: PluralStringResource by lazy {
      PluralStringResource("plurals:activity__list_items_added", "activity__list_items_added", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 126),
      ))
    }

@delegate:ResourceContentHash(-363_419_495)
internal val Res.plurals.comments__show_replies: PluralStringResource by lazy {
      PluralStringResource("plurals:comments__show_replies", "comments__show_replies", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137, 86),
      ))
    }

@delegate:ResourceContentHash(-1_237_681_294)
internal val Res.plurals.exception__count: PluralStringResource by lazy {
      PluralStringResource("plurals:exception__count", "exception__count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224, 68),
      ))
    }

@delegate:ResourceContentHash(1_223_056_714)
internal val Res.plurals.game__languages_count: PluralStringResource by lazy {
      PluralStringResource("plurals:game__languages_count", "game__languages_count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 343, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293, 81),
      ))
    }

@delegate:ResourceContentHash(-793_554_792)
internal val Res.plurals.game__reviews_count: PluralStringResource by lazy {
      PluralStringResource("plurals:game__reviews_count", "game__reviews_count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 439, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 375, 71),
      ))
    }

@delegate:ResourceContentHash(-1_897_997_390)
internal val Res.plurals.gamelist__columns_count: PluralStringResource by lazy {
      PluralStringResource("plurals:gamelist__columns_count", "gamelist__columns_count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 519, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 447, 75),
      ))
    }

@delegate:ResourceContentHash(-1_969_499_551)
internal val Res.plurals.gamelist__pick_confirm: PluralStringResource by lazy {
      PluralStringResource("plurals:gamelist__pick_confirm", "gamelist__pick_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 617, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 523, 82),
      ))
    }

@delegate:ResourceContentHash(1_895_024_664)
internal val Res.plurals.home__release_in_days: PluralStringResource by lazy {
      PluralStringResource("plurals:home__release_in_days", "home__release_in_days", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 750, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 606, 73),
      ))
    }

@delegate:ResourceContentHash(-1_118_601_967)
internal val Res.plurals.lists__count_games: PluralStringResource by lazy {
      PluralStringResource("plurals:lists__count_games", "lists__count_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 858, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 680, 66),
      ))
    }

@delegate:ResourceContentHash(628_978_807)
internal val Res.plurals.profile__followers_count: PluralStringResource by lazy {
      PluralStringResource("plurals:profile__followers_count", "profile__followers_count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 929, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 747, 84),
      ))
    }

@delegate:ResourceContentHash(2_120_145_574)
internal val Res.plurals.profile__following_count: PluralStringResource by lazy {
      PluralStringResource("plurals:profile__following_count", "profile__following_count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1014, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 832, 84),
      ))
    }

@delegate:ResourceContentHash(-263_064_777)
internal val Res.plurals.settings__import_done: PluralStringResource by lazy {
      PluralStringResource("plurals:settings__import_done", "settings__import_done", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1091, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 917, 93),
      ))
    }

@delegate:ResourceContentHash(1_619_866_792)
internal val Res.plurals.settings__import_selected: PluralStringResource by lazy {
      PluralStringResource("plurals:settings__import_selected", "settings__import_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1223, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1011, 93),
      ))
    }

@delegate:ResourceContentHash(-871_110_583)
internal val Res.plurals.stats__ratings_count: PluralStringResource by lazy {
      PluralStringResource("plurals:stats__ratings_count", "stats__ratings_count", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1359, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1105, 72),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("activity__list_items_added", Res.plurals.activity__list_items_added)
  map.put("comments__show_replies", Res.plurals.comments__show_replies)
  map.put("exception__count", Res.plurals.exception__count)
  map.put("game__languages_count", Res.plurals.game__languages_count)
  map.put("game__reviews_count", Res.plurals.game__reviews_count)
  map.put("gamelist__columns_count", Res.plurals.gamelist__columns_count)
  map.put("gamelist__pick_confirm", Res.plurals.gamelist__pick_confirm)
  map.put("home__release_in_days", Res.plurals.home__release_in_days)
  map.put("lists__count_games", Res.plurals.lists__count_games)
  map.put("profile__followers_count", Res.plurals.profile__followers_count)
  map.put("profile__following_count", Res.plurals.profile__following_count)
  map.put("settings__import_done", Res.plurals.settings__import_done)
  map.put("settings__import_selected", Res.plurals.settings__import_selected)
  map.put("stats__ratings_count", Res.plurals.stats__ratings_count)
}
